/* eslint-disable max-classes-per-file */
import React, { PropsWithChildren, PureComponent } from 'react';
import listensToClickOutside from 'react-onclickoutside';
import './dropdown.scss';
// eslint-disable-next-line import/order
import PropTypes from 'prop-types';

type DropdownProps = {
    seleniumId: string;
    hideOnUrlClick: boolean;
    onClickOutside: () => void;
} & PropsWithChildren;

class Dropdown extends PureComponent<DropdownProps> {
    static propTypes = {
        children: PropTypes.node,
        hideOnUrlClick: PropTypes.bool,
        onClickOutside: PropTypes.func.isRequired,
    };

    dropdownRef = React.createRef<HTMLDivElement>();

    static defaultProps = {
        children: null,
        hideOnUrlClick: false,
    };

    componentDidMount() {
        this.dropdownRef.current?.addEventListener('focusout', event => {
            if (!this.dropdownRef.current?.contains(event.relatedTarget as Node)) {
                this.handleClickOutside();
            }
        });
    }

    // eslint-disable-next-line react/no-unused-class-component-methods
    handleClickOutside = () => this.props.onClickOutside();

    onClick = e => {
        if (this.props.hideOnUrlClick && e?.target?.tagName === 'A') {
            this.handleClickOutside();
        }
    };

    onEscape = e => {
        if (e.key === 'Escape') {
            this.handleClickOutside();
        }
    };

    render() {
        const { children, seleniumId } = this.props;

        return (
            // eslint-disable-next-line jsx-a11y/no-static-element-interactions
            <section
                ref={this.dropdownRef}
                className="UserNameDropdown bottom-center"
                data-seleniumid={seleniumId}
                onClick={this.onClick}
                onKeyDown={this.onEscape}
            >
                {children}
            </section>
        );
    }
}

export default listensToClickOutside(Dropdown);
